import { render, staticRenderFns } from "./edit_stage.vue?vue&type=template&id=819e4656&scoped=true"
import script from "./edit_stage.vue?vue&type=script&lang=js"
export * from "./edit_stage.vue?vue&type=script&lang=js"
import style0 from "./edit_stage.vue?vue&type=style&index=0&id=819e4656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819e4656",
  null
  
)

export default component.exports